import React, { Component } from "react";
import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    section: state.section,
  };
}

class Portfolio extends Component {
  componentDidMount() {
    this.props.dispatch({
      type: "SectionSelected",
      payload: "Portfolio",
    });
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <h2>Coming soon</h2>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Portfolio);
